export default __webpack_public_path__ + "static/media/mys-chindli-chumm-weidli.b51ba6ee.webp";